module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9KSytn/tc-custom/9781945547577.jpg?1721442278213",
      "alt": "This image is the cover for the book 101 Amazing Uses for Coconut Oil"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Amazing Uses for Coconut Oil\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Discover surprising and practical uses for this flavorful, antibacterial oil—from soothing burns and whitening your teeth to removing makeup.")]), _c('br'), _c('br'), _vm._v("Coconut oil is a well-known super food, but the benefits extend far beyond the kitchen. In "), _c('i', [_vm._v("101 Amazing Uses for Coconut Oil")]), _vm._v(", nutrition consultant reveals how this widely available product can boost your metabolism, heal cold sores, reduce hypertension, and so much more."), _c('br'), _c('br'), _vm._v("Branson’s "), _c('i', [_vm._v("101 Amazing Uses")]), _vm._v(" series reveals the practical yet little-known uses for common natural products, including ginger, aloe vera, apple cider vinegar and more. Each book is filled with easy-to-read, bite-sized benefits for everything from health to beauty to household cleaning.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Branson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Familius Llc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0